import React from "react";
import "./banner.m.css";
import { getLoginLink } from "../../pages/login/sso-utils";
import { CustomLink } from "../../custom-link";

export function getPaywallButtons(
  buttonType,
  buttonTxt = "",
  buttonColor,
  buttonTextColor,
  member,
  sso,
  localizedMagazineSubscription,
  magazineSlug,
  isPbPreview
) {
  const primaryButtonStyle = "banner-button banner-primary-button";
  const secondaryButtonStyle = "banner-button banner-magazine-button";

  if (isPbPreview) {
    return (
      <div
        className={primaryButtonStyle}
        styleName={primaryButtonStyle}
        style={{ backgroundColor: buttonColor, color: buttonTextColor === "dark" ? "#000" : "#fff" }}
      >
        {buttonTxt}
      </div>
    );
  }

  if (buttonType === "subscribe") {
    return (
      <div>
        {magazineSlug &&
          getMagazineSubcriptionButton(magazineSlug, localizedMagazineSubscription, secondaryButtonStyle)}
        <div
          styleName={primaryButtonStyle}
          style={{ backgroundColor: buttonColor, color: buttonTextColor === "dark" ? "#000" : "#fff" }}
        >
          <CustomLink href={"/subscription"}> {buttonTxt || "Subscribe"}</CustomLink>
        </div>
      </div>
    );
  }

  return (
    <div
      styleName={primaryButtonStyle}
      onClick={(e) => getLoginLink(member, sso)}
      style={{ backgroundColor: buttonColor, color: buttonTextColor === "dark" ? "#000" : "#fff" }}
    >
      {buttonTxt || "Sign in"}
    </div>
  );
}

function getMagazineSubcriptionButton(magazineSlug, localizedMagazineSubscription, secondaryButtonStyle) {
  return (
    <div styleName={secondaryButtonStyle}>
      <CustomLink href={`/subscription?group=${magazineSlug}`}>
        {localizedMagazineSubscription || "Magazine Subscription"}
      </CustomLink>
    </div>
  );
}
